import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useEffect , useState } from 'react';
import { NumberWithCommas } from "../../share/NumberWithCommas";
import {RiFileExcel2Line} from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import './Reports.css'
// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report199() {
    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [Re199data, setRe199data] = useState([]);

    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNewn BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }

    async function getR199() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        const res199 = await fetch("/api/BorrowReports/getV199", {
            method: 'POST',
            body: formData
        })
        const Re199data = await res199.json()
        setRe199data(Re199data.dataenum)
        console.log(Re199data)
    }

    const [Re199yeardata, setRe199yeardata] = React.useState([]);
    async function getR199year() {
        const res = await fetch("/api/BorrowReports/getyear199")
        const Re199yeardata = await res.json()
        setRe199yeardata(Re199yeardata.dataenum)
        console.log(Re199yeardata)
    }



    const y2 = Re199yeardata.filter(n => n.yearTh >= othYearSelected);


    useEffect(() => {
        getR199()
        getR199year()
    }, [thYearSelected, othYearSelected]);



    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'สถานประกอบกิจการที่กู้ยืมเงินกองทุน', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'จำนวนสถานประกอบกิจการ(แห่ง)', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'จำนวนลูกจ้าง(คน)', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'วงเงินกู้ยืม(บาท)', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'จำนวนลูกจ้างที่ได้รับการพัฒนาฝีมือแรงงาน(คน)', colSpan: 3, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, {}, { text: 'ร้อยละของจำนวนลูกจ้างที่ได้รับการฝึกอบรม', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ร้อยละของจำนวนลูกจ้างที่ได้รับการพัฒนาฝีมือแรงงาน', rowSpan: 2, fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }],
    //     [{}, {}, {}, {}, { text: 'ฝึกอบรม', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'ทดสอบ', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, { text: 'รวม', fillColor: '#cccccc', bold: true, style: 'tableHeader', alignment: 'center' }, {}, {}],];
    //     Re199data.forEach(function (item) {
    //         var rowdata = [{ text: item.sizeEmp, alignment: 'left' }, { text: item.companySum, alignment: 'right' }, { text: (NumberWithCommas(item.employeeAmount)), alignment: 'right' }, { text: (NumberWithCommas(item.amountApprove)), alignment: 'right' }, { text: item.personTrain, alignment: 'right' }, { text: item.personTest, alignment: 'right' }, { text: item.personSum, alignment: 'right' }, { text: item.personTrainPercent.toFixed(2), alignment: 'right' }, { text: item.personSumPercent.toFixed(2), alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'สรุปข้อมูลขนาดสถานประกอบกิจการที่กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน', style: 'header', bold: true, alignment: 'center', fontSize: 20 },
    //             { text: 'ประจำปีงบประมาณ พ.ศ. ' + othYearSelected + ' ' + '-' + ' ' + thYearSelected, bold: true, alignment: 'center', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 100, 100],
    //                     body: tablebody
    //                 },
    //             }],
                
    //             defaultStyle: {
    //                 font: 'THSarabunNew'
    //             }
    
    //         }
    //         pdfMake.createPdf(docDefinition).download('R199')
    //     }


    let sum1 = Re199data.reduce(function (prev, current) {
        return prev + +current.companySum
    }, 0);
    let sum2 = Re199data.reduce(function (prev, current) {
        return prev + +current.employeeAmount
    }, 0);
    let sum3 = Re199data.reduce(function (prev, current) {
        return prev + +current.amountApprove
    }, 0);
    let sum4 = Re199data.reduce(function (prev, current) {
        return prev + +current.personTrain
    }, 0);
    let sum5 = Re199data.reduce(function (prev, current) {
        return prev + +current.personTest
    }, 0);
    let sum6 = Re199data.reduce(function (prev, current) {
        return prev + +current.personSum
    }, 0);

    let sum7 = (sum4 * 100) / sum2;
    let sum8 = (sum6 * 100) / sum2;


    return (
        <Container>
            <div>

                {/* <div style={{ display: 'flex', paddingBottom: '10px', justifyContent: 'center' }}>
                    <h3 style={{ paddingTop: '2px' }} className='text-center'>
                        ปีงบประมาณ พ.ศ.
                    </h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            setOThYearSelected(e.target.value)
                        }}
                    >
                        {Re199yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                    <h3 style={{ lineHeight: 'inherit' }}>ถึง</h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div> */}
                <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ปีงบประมาณ พ.ศ.</span>
                    <Input
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            if(e.target.value !== "กรุณาเลือก"){
                                setOThYearSelected(e.target.value)
                            } else {
                                return;
                            }
                            
                        }}
                    >
                        <option disabled defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                        {Re199yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                        
                    </Input>
                    <span className='header-select-year mx-3'> ถึง </span>
                    <Input
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            if(e.target.value !== "กรุณาเลือก"){
                                setThYearSelected(e.target.value)
                            } else {
                                return;
                            }
                            
                        }}
                    >
                        <option disabled defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                        
                    </Input>
                   
                </div>
                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV199?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR199?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV199?thYear=${thYearSelected}&othYear=${othYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR199?thYear=${thYearSelected}&othYear=${othYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>
                <div className="report-wrapper">
                <Table className="styled-table text-center" bordered striped hover>
                    <thead className='styles-thead'>
                        <tr>
                            <th rowSpan="2">
                                สถานประกอบกิจการที่กู้ยืมเงินกองทุน
                            </th>
                            <th rowSpan="2">
                                จำนวนสถานประกอบกิจการ(แห่ง)
                            </th>
                            <th rowSpan="2">
                                จำนวนลูกจ้าง(คน)
                            </th>
                            <th rowSpan="2">
                                วงเงินกู้ยืม(บาท)
                            </th>
                            <th colSpan="3" className=' text-center'>
                                จำนวนลูกจ้างที่ได้รับการพัฒนาฝีมือแรงงาน(คน)
                            </th>
                            <th rowSpan="2">
                                ร้อยละของจำนวนลูกจ้างที่ได้รับการฝึกอบรม
                            </th>
                            <th rowSpan="2">
                                ร้อยละของจำนวนลูกจ้างที่ได้รับการพัฒนาฝีมือแรงงาน
                            </th>
                        </tr>
                        <tr>
                            <th className='text-center'>
                                ฝึกอบรม
                            </th>
                            <th className='text-center'>
                                ทดสอบ
                            </th>
                            <th className='text-center'>
                                รวม
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {Re199data.length > 0 && Re199data.map((item, i) => (

                            <tr >
                                <th scope="row">
                                    {item.sizeEmp}
                                </th>
                                <td className='text-end'>
                                    {item.companySum}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.employeeAmount)}
                                </td>
                                <td className='text-end'>
                                    {NumberWithCommas(item.amountApprove)}
                                </td>
                                <td className='text-end'>
                                    {item.personTrain}
                                </td>
                                <td className='text-end'>
                                    {item.personTest}
                                </td>
                                <td className='text-end'>
                                    {item.personSum}
                                </td>
                                <td className='text-end'>
                                    {item.personTrainPercent.toFixed(2)}%
                                </td>
                                <td className='text-end'>
                                    {item.personSumPercent.toFixed(2)}%
                                </td>
                            </tr>
                        )) || <tr><td colSpan="14" rowSpan="6" className='text-center'>ไม่มีข้อมูลในระบบ</td></tr>}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th scope="row" className='text-end'>
                                รวม
                            </th>
                            <td className='text-end'>
                                {sum1}
                            </td>
                            <td className='text-end'>
                                {sum2}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum3)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum4)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum5)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum6)}
                            </td>
                            <td className='text-end'>
                                {sum7.toFixed(2)}%
                            </td>
                            <td className='text-end'>
                                {sum8.toFixed(2)}%
                            </td>
                        </tr>
                    </tfoot>
                </Table>
                </div>

            </div>

        </Container>
    );


}
